<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" sm="9" md="10">
        <b-row>
          <b-col>
            <h3>
              <b-badge variant="primary">
                Exceptions
              </b-badge>
              <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
            </h3>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Household ID: </b-col>
          <b-col>{{ HHID }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Family Name: </b-col>
          <b-col>{{ FamilyName }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Claim ID: </b-col>
          <b-col>{{ ClaimID }}</b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="3" md="2">
        <b-row>
          <b-col>
            <b-button
              block
              class="mb-2 mt-2 pb-2 pt-2"
              @click="$router.go(-1)">
              Back
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              :disabled="canAddExceptions"
              block
              class="mb-2 mt-2 pb-2 pt-2"
              @click="$router.push({path: `/addhouseholdexception/${HHID}`})">
              Add Household Exception
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              :disabled="canAddExceptions"
              block
              class="mb-2 mt-2 pb-2 pt-2"
              @click="$router.push({path: `/addindividualexception/${HHID}`})">
              Add Individual Exception
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-table 
      small
      responsive
      striped
      stacked="sm"
      :busy="waiting"
      :items="items" 
      :fields="fields">
      <!-- scoped The Issue slot -->
      <template slot="TheIssue" slot-scope="row">
        <div v-if="isLongIssue(row.item.TheIssue)">
          {{ row.item.TheIssue.substring(1,255) }} ...
          <b-button
            size="sm"
            @click="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} full issue
          </b-button>
        </div>
        <div v-else>
          {{ row.item.TheIssue }}
        </div>
      </template>
      <!-- row details -->
      <template slot="row-details" slot-scope="row">
        <p v-if="!waiting">{{ row.item.TheIssue }}</p>
      </template>
      <!--  -->
      <template slot="InterviewSuccessful" slot-scope="data">
        <b-form-checkbox
          disabled
          v-model="data.item.InterviewSuccessful">
        </b-form-checkbox>
      </template>
      <div slot="table-busy" class="text-center text-danger">
        <b-spinner class="align-middle"></b-spinner>
        <!-- <strong>Loading...</strong> -->
      </div>
    </b-table>
  </b-container>
</template>

<script>
import { apiService } from '../_services'
import { mapGetters } from 'vuex'

export default {
  name: 'Exceptions',
  data() {
    return {
      waiting: false,
      HHID: '',
      FamilyName: '',
      ClaimID: '',
      items: [],
      fields: [
        {
          key: 'IssueForm',
          label: 'Issue Form'
        },
        {
          key: 'PID',
          label: 'PID'
        },
        {
          key: 'TheIssue',
          label: 'The Issue'
        },
        {
          key: 'RejectAccept',
          label: 'Reject/Accept'
        },
        {
          key: 'InterviewSuccessful',
          label: 'Interview Successful'
        },
        {
          key: 'DateRaised',
          label: 'Date Raised'
        },
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getHouseholdExceptions(this.HHID)
    .then((response) => {
      vm.FamilyName = response.data.FamilyName
      vm.ClaimID = response.data.ClaimID
      vm.items = response.data.ExceptionList
      this.waiting = false
    })
  },
  computed: {
    ...mapGetters('auth', ['getIsAdminHQ', 'getIsSupportHQ']),
    canAddExceptions() {
      return !(this.getIsAdminHQ || this.getIsSupportHQ)
    }
  },
  methods: {
    isLongIssue(issue) {
      return issue.length > 255
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/HouseholdExceptionsPage.vue